import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { INTERVIEWS_QUERIES } from "~/shared/api/interviews/interviews.queries";
import { notFound } from "~/shared/util/notFound";

export async function interviewLoader({ params, request }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { interviewId } = params;

  if (!interviewId) {
    return notFound();
  }

  await queryClient.ensureQueryData(INTERVIEWS_QUERIES.member.detail(interviewId));
}
